import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsRecommendedPackagePaymentStatusCheckInProgress } from '../../../../../../../reducers/v2/paymentProcessing/selectors';
import { setSelectedRecommendedPackageId } from '../../../../../../../actions/recommendedPackages';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';
import { IRecommendedPackage } from '../../../../../../../types/reducers/recommendedPackages';
import { useAppContext } from '../../../../../../../../AppModulesWrapper';
import { useRecommendedPackagesAnalytics } from './useRecommendedPackagesAnalytics';
import { buyPackageThunk } from '../../../../../../../thunks/recommendedPackages/buyPackage';
import { buyPackageNativeThunk } from '../../../../../../../thunks/recommendedPackages/buyPackageNative';
import {
  selectDefaultRecommendedPackagePublicationPrice,
  selectIsRecommendedPackagesAvailable,
  selectRecommendedPackages,
} from '../../../../../../../reducers/v2/recommendedPackages/selectors';

export const useRecommendedPackages = () => {
  const dispatch = useDispatch();
  const isMobile = useSelector(selectIsMobileLayout);
  const { config, custom } = useAppContext();
  const isNativeCheckoutEnabled = !!config.get('servicePickerWidget.WebView.isNativeCheckoutEnabled');

  const { trackShowRecommendedPackagesWidget, trackDefaultPublicationClick, trackRecommendedPackageClick } =
    useRecommendedPackagesAnalytics();

  const isPaymentStatusCheckInProgress = useSelector(selectIsRecommendedPackagePaymentStatusCheckInProgress);

  const isRecommendedPackagesAvailable = useSelector(selectIsRecommendedPackagesAvailable);
  const isRender = !isPaymentStatusCheckInProgress && isRecommendedPackagesAvailable;

  const recommendedPackages = useSelector(selectRecommendedPackages);
  const offerPrice = useSelector(selectDefaultRecommendedPackagePublicationPrice);

  const handleDefaultPublicationClick = useCallback(() => {
    dispatch(setSelectedRecommendedPackageId(null));

    trackDefaultPublicationClick();
  }, [dispatch, trackDefaultPublicationClick]);

  const handleRecommendedPackageClick = useCallback(
    (recommendedPackage: IRecommendedPackage) => {
      trackRecommendedPackageClick(recommendedPackage);

      dispatch(setSelectedRecommendedPackageId(recommendedPackage.id));

      if (isNativeCheckoutEnabled && custom.useAppsCheckout) {
        dispatch(buyPackageNativeThunk());
      } else {
        dispatch(buyPackageThunk());
      }
    },
    [custom.useAppsCheckout, dispatch, isNativeCheckoutEnabled, trackRecommendedPackageClick],
  );

  useEffect(() => {
    if (isRender) {
      trackShowRecommendedPackagesWidget();
    }
  }, [isRender, trackShowRecommendedPackagesWidget]);

  return {
    isRender,
    isMobile,
    offerPrice,
    recommendedPackages,
    handleDefaultPublicationClick,
    handleRecommendedPackageClick,
  };
};
